module.exports = __webpack_public_path__ + "img/product_41.d3ee242.webp";